import React from 'react';
import { useT } from '@/contexts/I18nContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface PerspectiveFieldsProps {
  width: string;
  height: string;
  onChange: (field: 'perspective_width' | 'perspective_height', value: string) => void;
  onBlur?: () => void;
  /** present => show recalc button (points available to recompute from). */
  onRecalc?: () => void;
}

const PerspectiveFields: React.FC<PerspectiveFieldsProps> = ({ width, height, onChange, onBlur, onRecalc }) => {
  const { t } = useT();
  return (
    <div className="space-y-1">
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor="f-pw">{t('zoning.form.labelPerspectiveWidth')}</Label>
          <Input
            id="f-pw" type="number" value={width}
            onChange={(e) => onChange('perspective_width', e.target.value)}
            onBlur={onBlur}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="f-ph">{t('zoning.form.labelPerspectiveHeight')}</Label>
          <Input
            id="f-ph" type="number" value={height}
            onChange={(e) => onChange('perspective_height', e.target.value)}
            onBlur={onBlur}
          />
        </div>
      </div>
      {onRecalc && (
        <Button type="button" variant="outline" className="h-7 px-2 text-xs" onClick={onRecalc} title={t('zoning.form.recalcHint')}>
          <RefreshCw className="size-3" />
          {t('zoning.form.recalcPerspective')}
        </Button>
      )}
    </div>
  );
};

export default PerspectiveFields;
